//意向

import UltMeta, { Meta } from "./UltMeta/index";

class PurType extends UltMeta {
    JOINT = new Meta(1, "联合采购");
    DIRECT = new Meta(2, "直采");
}

export const PUR_TYPE = new PurType();

/**
 * 后台管理状态
 */
class State extends UltMeta {
    STAY_ASSIGN = new Meta(1, "待分派");
    PENDING = new Meta(2, "待处理");
    REJECTED = new Meta(3, "已驳回");
    PROCESSING = new Meta(4, "处理中");
    WAIT_AUDIT = new Meta(5, "待审核");
    WAIT_CONFIRM = new Meta(6, "待确认");
    CONFIRMED = new Meta(7, "已确认");
    STRANDING = new Meta(8, "已搁浅");
    COMPLETED = new Meta(9, "已完成");
    CLOSED = new Meta(10, "已关闭");
}

export const STATE = new State();

/**
 * 小程序状态
 */
class CustomerState extends UltMeta {
    PENDING = new Meta(1, "待处理");
    PROCESSING = new Meta(2, "处理中");
    WAIT_CONFIRM = new Meta(3, "待确认");
    CONFIRMED = new Meta(4, "已确认");
    STRANDING = new Meta(5, "已搁浅");
    COMPLETED = new Meta(6, "已完成");
}

export const CUSTOMER_STATE = new CustomerState();

/**
 * 价格类型
 */
class PriceType extends UltMeta {
    ONE = new Meta(1, "100 万以下");
    TWO = new Meta(2, "100 万 - 300 万");
    THREE = new Meta(3, "300 万 - 500 万");
    FOUR = new Meta(4, "500 万以上");
}

export const PRICE_TYPE = new PriceType();

/**
 * 审核类型
 */
class AuditType extends UltMeta {
    AGREE = new Meta(1, "同意");
    REJECT = new Meta(2, "拒绝");
}

export const AUDIT_TYPE = new AuditType();

/**
 * 服务费类型
 */
class ServiceCostType extends UltMeta {
    UNIT_PRICE = new Meta(1, "单价收费");
    FIXED_PRICE = new Meta(2, "一口价");
}

export const SERVICE_COST_TYPE = new ServiceCostType();
